import { connect } from 'react-redux'
import {
  getFeatureModuleType,
  getFeatureModuleName,
  getFeatureType,
} from 'selectors/feature/featureMetadata'
import { makeGetHasErrors } from 'selectors/validation'
import { makeGetScalingQueryProps } from 'selectors/feature/scalingQueries'
import { getLogicNode } from 'selectors/feature/logicNodes'
import { getIsSimulating } from 'selectors/navigator'
import {
  makeLogicSetSimulationsSelector,
  getIsActiveSimulatedPowerNetLevel,
  getIsSimulatedVirtualFuseOpen,
} from 'selectors/feature/simulation'
import {
  makeGetOutputQueryDescription,
  makeOutputAssignmentDescription,
  getOutputQuery,
} from 'selectors/feature/outputs'
import OutputNode from './OutputNode'

const makeMapStateToProps = () => {
  const getOutputAssignmentDescription = makeOutputAssignmentDescription()
  const getOutputQueryDescription = makeGetOutputQueryDescription()
  const getHasOutputErrors = makeGetHasErrors()
  const getHasFnErrors = makeGetHasErrors()
  const getScalingQueryErrors = makeGetHasErrors()
  const getScalingQueryProps = makeGetScalingQueryProps()
  const simulationsSelector = makeLogicSetSimulationsSelector()

  return (state, ownProps) => {
    const {
      output: { id, fnId, mappedOutputId, scalingQuery },
    } = ownProps
    const featureModuleType = getFeatureModuleType(state)
    const featureModuleName = getFeatureModuleName(state)
    const outputQuery = getOutputQuery(state, { fnId })
    const isSimulating = getIsSimulating(state)
    const sims = simulationsSelector(state, { queryUri: id })

    const isActivePowerNetLevel = getIsActiveSimulatedPowerNetLevel(state, {
      powerNetLevel: ownProps.output.powerNetLevel,
    })

    const virtualFuseOpen = getIsSimulatedVirtualFuseOpen(state, {
      outputId: id,
    })

    const singleInputNode = getLogicNode(state, {
      queryUri: outputQuery.uri,
    })

    const outputQueryDescription = getOutputQueryDescription(state, {
      fnId,
      id,
    })
    const outputQueryType = outputQuery.queryType
    const outputAssignmentDescription = getOutputAssignmentDescription(state, {
      id: mappedOutputId,
    })
    const hasOutputErrors = getHasOutputErrors(state, { id })
    const hasFnErrors = getHasFnErrors(state, { id: fnId })
    const hasScalingQueryErrors = getScalingQueryErrors(state, {
      id: scalingQuery,
    })
    const scalingQueryProps = getScalingQueryProps(state, {
      uri: scalingQuery,
    })
    const featureType = getFeatureType(state)

    return {
      ...sims,
      isOutput: true, // for determining styles. output nodes use the same style wrapper as logic sets and timers, etc.
      isSimulating,
      isActivePowerNetLevel,
      featureModuleType,
      featureModuleName,
      outputQueryDescription,
      outputAssignmentDescription,
      outputQueryType,
      hasErrors: hasOutputErrors || hasFnErrors || hasScalingQueryErrors,
      outputQuery,
      queryTranslations: singleInputNode.translations,
      queryTranslationType: singleInputNode.translationType,
      scalingQueryProps,
      featureType,
      virtualFuseOpen,
    }
  }
}

const OutputNodeContainer = connect(makeMapStateToProps)(OutputNode)

export default OutputNodeContainer
